import {
    DreamTeamCrossFunctionId,
    DreamTeamFunctionType,
    TeamImprovementId
} from '../constants-types/StrategyConstants';
import { DreamTeamActionText } from './Group.model';

export type TeamServerEntry = {
    teamName: string;
    teamFunctionType: DreamTeamFunctionType;
    otherTeamFunction: string;
    crossFunctionId: DreamTeamCrossFunctionId;
    teamImprovementIds: string;
    otherTeamImprovement: string;
    teamId: string;
    teamItemsCount: number;
    teamOwnerId: string;
    groupName: string; // TODO: remove this property after the Groups -> Teams migration
    groupId: string; // TODO: remove this property after the Groups -> Teams migration
    groupItemsCount: number; // TODO: remove this property after the Groups -> Teams migration
    groupOwnerId: string; // TODO: investigate if a "team" equivalent of this property exists in the Groups -> Teams migration
    ownerInfo: {
        userId: string;
        email: string;
        name: {
            first: string;
            last: string;
        };
    };
    isEditableByUser: boolean;
    isEditableBySharedUsers: boolean;
    createdTime: string;
    modifiedTime: string;
    isStrategyAutoSelectionEnabled: boolean;
};

export type TeamServer = TeamServerEntry[];

export type TeamPatch = {
    teamName: string;
    teamFunctionType: DreamTeamFunctionType;
    otherTeamFunction: string;
    crossFunctionId: DreamTeamCrossFunctionId;
    teamImprovementIds: TeamImprovementId[];
    otherTeamImprovement: string;
    isStrategyAutoSelectionEnabled: boolean;
    isEditableBySharedUsers: boolean;
};

export type TeamItemPatch = {
    personId: string;
    isManager: boolean;
};

export type TeamCreatePost = {
    teamName: string;
    teamFunctionType: DreamTeamFunctionType;
    otherTeamFunction: string;
    crossFunctionId: DreamTeamCrossFunctionId;
    teamImprovementIds: TeamImprovementId[];
    otherTeamImprovement: string;
};

export class GroupValidatePost {
    groupIds: string[];
    userIds: string[];
}

export type GroupValidateUserAccessServer = {
    groupId: string;
    userId: string;
    userFirstName: string;
    userLastName: string;
    userEmail: string;
    personId: string;
    personFirstName: string;
    personLastName: string;
    personEmail: string;
    jobId: string;
    jobName: string;
    folderId: string;
    folderName: string;
    folderPath: string;
};

export type SharedGroupsValidateServer = {
    checkUsersAccessToGroupsReturnsDtos: GroupValidateUserAccessServer[];
};

export type SharedGroupsForUserServer = {
    myGroupDetailReturns: TeamServerEntry[];
};

export type SharedGroupsGetUsersForGroupServer = {
    returnItems: {
        userId: string;
        userFirstName: string;
        userLastName: string;
        userEmail: string;
        isThirdPartyUser: boolean;
        roleName: string;
        userRole: number;
    }[];
};

export type SharedGroupsGrantUserAccessResponse = {
    numberOfItemsProcessed: number;
};

export type SharedGroupUserAccessPost = {
    groupId: string;
    userId: string;
    folderId?: string;
};

export type SharedGroupsValidatePost = {
    userCompanyMyGroupIdList: {
        uniqueId: string;
    }[];
    userIdList: {
        uniqueId: string;
    }[];
};

export type SharedGroupsUsersFoldersPost = {
    sharedGroupsUsersFoldersParameters: {
        userCompanyMyGroupGuid: string;
        userGuid: string;
        itemFolderGuid?: string;
    }[];
};

export type DreamTeamGetTeamInsightsServer = {
    title: string;
    version: string;
    teamSizes: {
        overallAverageSize: number;
        sizesByTeamFunction: { [key: string]: number };
    };
    teamStrategyFrequencies: {
        teamStrategyFrequencyPercentagesByTeamTypeAndStrategy: {
            [key: string]: { [key: string]: number };
        };
    };
    teamActionRankings: Map<string, DreamTeamActionRankingServer>;
    teamTypeFrequencies: {
        teamTypeFrequencyPercentagesByTeamType: { [key: string]: number };
        teamTypeFrequencyPercentagesByTeamFunctionAndType: {
            [key: string]: { [key: string]: number };
        };
    };
};

export type DreamTeamGetTeamActionsDefinitionServer = {
    teamActionsByTeamType: Map<string, DreamTeamActionText[]>;
};

export type DreamTeamActionRankingServer = {
    actionId: number;
    averageRanking: number;
    ratingCount: number;
};
